__turbopack_context__.v({
  "item": "index-module__L7PaqG__item",
  "separator": "index-module__L7PaqG__separator",
  "visuallyHidden": "index-module__L7PaqG__visuallyHidden",
});
